import React, { FC, useCallback, useState } from 'react';
import { Button, DatePicker, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import moment from 'moment';
import DateTimeHover from '../date_time_component/DateTime';
import { isDatePastDue } from '../../utils/DataFormatterUtils';

const DUE_DATE_FORMAT = 'MMM D, YYYY';

const PODueDateDisplay: FC<any> = ({ dueDate, timeZoneId, onSave, editable = true }) => {
	const [editing, setEditing] = useState(false);
	const [saving, setSaving] = useState(false);

	const startEditing = useCallback(() => setEditing(true), []);

	const handleChange = useCallback(
		(value) => {
			setSaving(true);
			onSave(value ? value.format('YYYY-MM-DD') : null)
				.then(() => setEditing(false))
				.catch((err) => message.error(err || 'Unable to update due date.'))
				.finally(() => setSaving(false));
		},
		[onSave]
	);

	const handleOpenChange = useCallback((open) => {
		if (!open) {
			setEditing(false);
		}
	}, []);

	if (editing) {
		return (
			<DatePicker
				autoFocus
				open
				allowClear={false}
				disabled={saving}
				defaultValue={dueDate ? moment(dueDate) : undefined}
				format={DUE_DATE_FORMAT}
				onChange={handleChange}
				onOpenChange={handleOpenChange}
				style={{ width: 200 }}
			/>
		);
	}

	const pastDue = dueDate && isDatePastDue(dueDate);

	return (
		<div className="flex flex-row items-center">
			{dueDate ? (
				<span style={pastDue ? { color: 'rgb(163, 40, 40)' } : {}}>
					<DateTimeHover timestamp={dueDate} timeZone={timeZoneId} showTime={false} />
				</span>
			) : (
				<span className="text-gray-400">Not set</span>
			)}
			{editable ? (
				<Button
					type="link"
					icon={<EditOutlined />}
					loading={saving}
					disabled={saving}
					onClick={startEditing}
				/>
			) : null}
		</div>
	);
};

export default PODueDateDisplay;
